import React from 'react';
import {
    withStyles,
} from '@material-ui/core'
import withWidth from '@material-ui/core/withWidth';

const iphoneXIcon = ({ width = 35, height = 35 } = {}) => (
    <svg width={width} height={height} viewBox="-17 0 160 140" xmlns="http://www.w3.org/2000/svg">
        <title/>
        <g>
            <title>background</title>
            <rect fill="none" id="canvas_background" height="132" width="126" y="-1" x="-1"/>
        </g>
        <g>
            <title>Layer 1</title>
            <path fill="#ffffff" id="svg_1"
                  d="m97.810203,54.048783l0,-43.16a7.9,7.9 0 0 0 -8,-7.75l-52,0a7.9,7.9 0 0 0 -8,7.75l0,108.5a7.9,7.9 0 0 0 8,7.75l52,0a7.9,7.9 0 0 0 8,-7.75l0,-65.34z"
                  className="cls-1"/>
            <path fill="#020202" id="svg_2"
                  d="m89.810203,129.138783l-52,0a9.89,9.89 0 0 1 -10,-9.75l0,-108.5a9.89,9.89 0 0 1 10,-9.75l52,0a9.89,9.89 0 0 1 10,9.75l0,108.5a9.89,9.89 0 0 1 -10,9.75zm-52,-124a5.89,5.89 0 0 0 -6,5.75l0,108.5a5.89,5.89 0 0 0 6,5.75l52,0a5.89,5.89 0 0 0 6,-5.75l0,-108.5a5.89,5.89 0 0 0 -6,-5.75l-52,0z"
                  className="cls-2"/>
            <path fill="#0a0a0a" id="svg_3"
                  d="m74.860203,13.138783l-22.1,0c-2.73,0 -4.95,-2.57 -4.95,-5.72l0,-3.79l4,0l0,3.79c0,1 0.57,1.72 0.95,1.72l22.1,0c0.38,0 0.95,-0.69 0.95,-1.72l0,-3.17l4,0l0,3.17c0,3.15 -2.22,5.72 -4.95,5.72z"
                  className="cls-2"/>
            <rect id="svg_4" height="5.314319" width="26.95119" y="4.483779" x="50.809101" strokeOpacity="null"
                  strokeWidth="null" stroke="null" fill="#0a0909"/>
        </g>
    </svg>

);

const iphoneIcon = ({ width = 35, height = 35 } = {}) => (
    <svg width={width} height={height} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <g>
            <title>background</title>
            <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
        </g>
        <g>
            <title>Layer 1</title>
            <rect stroke="#000" id="svg_1" height="374.503601" width="194.616411" y="69.197116" x="159.90566"
                  strokeWidth="1.5" fill="#fff"/>
            <path stroke="null" fill="#222222" fillRule="nonzero" strokeWidth="60" id="rect3010"
                  d="m180.236642,55.503797c-7.85377,0.000737 -15.6653,3.010045 -21.21875,8.188871c-5.55346,5.178817 -8.78046,12.463384 -8.78125,19.787342l0,345.039957c0.00079,7.323986 3.22779,14.608526 8.78125,19.787389c5.55345,5.178863 13.36498,8.188078 21.21875,8.188824l150,0c7.85377,-0.000746 15.6653,-3.009961 21.21875,-8.188824c5.55346,-5.178863 8.78046,-12.463403 8.78125,-19.787389l0,-345.039957c-0.00079,-7.323958 -3.22779,-14.608526 -8.78125,-19.787342c-5.55345,-5.178826 -13.36498,-8.188134 -21.21875,-8.188871l-150,0zm59.28125,18.650809a5.00625,4.668531 0 0 1 0.21875,0a5.0005,4.663168 0 0 1 0.5,0l30,0a5.0005,4.663168 0 1 1 0,9.325404l-30,0a5.0129,4.674732 0 0 1 -0.71875,-9.325404zm-79.28125,27.976213l190,0l0,303.075638l-190,0l0,-303.075638zm95,312.401042c8.28427,0 15,6.26269 15,13.988106c0,7.725445 -6.71573,13.988106 -15,13.988106c-8.28427,0 -15,-6.262662 -15,-13.988106c0,-7.725417 6.71573,-13.988106 15,-13.988106z"/>
        </g>
    </svg>
);

const ipadIcon = ({ width = 35, height = 35 } = {}) => (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 128 128">
        <g>
            <title>background</title>
            <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
        </g>
        <g>
            <title>Layer 1</title>
            <circle id="svg_1" r="3" fill="#000000" cy="103" cx="66"/>
            <path id="svg_2" fill="#000000"
                  d="m89,14l-49,0c-5.5,0 -10,4.5 -10,10l0,81c0,5.5 4.5,10 10,10l49,0c5.5,0 10,-4.5 10,-10l0,-81c0,-5.5 -4.5,-10 -10,-10zm6,91c0,3.3 -2.7,6 -6,6l-49,0c-3.3,0 -6,-2.7 -6,-6l0,-81c0,-3.3 2.7,-6 6,-6l49,0c3.3,0 6,2.7 6,6l0,81z"/>
            <path id="svg_3" fill="#000000" d="m40,24l0,72l49,0l0,-72l-49,0zm47,70l-45,0l0,-68l45,0l0,68z"/>
        </g>
    </svg>
);

const toLowerCase = str => str ? str.toLowerCase() : '';

function getIconFor(deviceName) {
    let nameLower = toLowerCase(deviceName);
    if (nameLower.indexOf('iphone') !== -1) {
        return nameLower.indexOf('x') !== -1 || nameLower.indexOf('11') !== -1 ? iphoneXIcon : iphoneIcon;
    }
    if (nameLower.indexOf('samsung') !== -1) {
        return iphoneXIcon;
    }
    return ipadIcon;
}

function DeviceIcon({ width, deviceName }) {
    let Icon = getIconFor(deviceName);
    return width === 'xs' ? Icon() : Icon({ width: 60, height: 60 });
}

export const styles = theme => ({
    icon: {
        marginLeft: '-7px',
        [theme.breakpoints.up('sm')]: {
            marginLeft: 'initial'
        }
    },
    itemButton: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        paddingTop: '5px',
        paddingBottom: '5px',
        marginBottom: '15px',
        cursor: 'pointer'
    },
});

export default withWidth()((withStyles(styles, { withTheme: true })(DeviceIcon)))
